import Layout from '@/layout'
const route = {
  path: '/approvedListing',
  component: Layout,
  // redirect: '/accountManagement/index',
  alwaysShow: true, // will always show the root menu
  name: 'approvedListingall',
  meta: {
    title: '过审链接',
    icon: 'reviewed',
    roles: [
      'reviewed_link.list'
    ]
  },
  children: [
    {
      path: '/approvedLink/index',
      component: () => import('@/views/approvedLink/index.vue'),
      name: 'approvedLink',
      meta: {
        title: '过审链接',
        roles: [
          'reviewed_link.list'
        ]
      }
    }
  ]
}

export default route
